import { useLocation } from 'react-router-dom';
import { logout, Tenant } from '@steelbuy/api-integration';
import { useEffectOnce } from '@steelbuy/util';
import { constants } from '../../constants';

export const Logout = () => {
    const { state } = useLocation();
    useEffectOnce(() => {
        (async () => {
            if (state?.refreshToken && state?.userId) {
                try {
                    await logout(constants.apiBaseUrl, state?.refreshToken, Tenant.MARKETPLACE, state?.userId);
                } catch (e) {
                    // logout failed
                }
            }
            // use window.location so we reset state
            let location = 'login';
            if (state?.queryParam) {
                location += `?${state?.queryParam}`;
            }
            window.location.assign(location);
        })();
    });
    return null;
};
